import type {
  FloorPlanMode,
  ProvinceCode,
  StreetDirection,
  StreetType,
} from '@/lib/types/property';

export const FLOOR_PLAN_MODE_OPTIONS: FloorPlanMode[] = ['hotspot', 'blank_canvas'];

export const STREET_TYPE_OPTIONS: StreetType[] = [
  'Ave',
  'Blvd',
  'Cir',
  'Cres',
  'Dr',
  'Gate',
  'Lane',
  'Pkwy',
  'Rd',
  'St',
  'Terr',
  'Way',
];

export const STREET_DIRECTION_OPTIONS: StreetDirection[] = [
  'N',
  'S',
  'E',
  'W',
  'NE',
  'NW',
  'SE',
  'SW',
];

export const PROVINCE_OPTIONS: ProvinceCode[] = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];
